export default __webpack_public_path__ + "static/media/google-pay.ea10596a.svg";